<script>
export default {
    name: "MiniDischargeReport",
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Mini-discharge Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Mini-discharge Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/5 sm:w-full p-tiny mt-px">
                  <input type="text" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny -mt-px">
                  <button class="btn-sm btn-info text-xs rounded"><i class="fa fa-filter"></i> Filter</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/12">MRN</th>
                            <th class="p-tiny w-1/12">Visit No</th>
                            <th class="p-tiny w-1/12">Patient</th>
                            <th class="p-tiny w-1/12">IPFileno</th>
                            <th class="p-tiny w-1/12">Ward Type</th>
                            <th class="p-tiny w-1/12">Admitted</th>
                            <th class="p-tiny w-1/12">Discharged</th>
                            <th class="p-tiny w-1/12">Ward</th>
                            <th class="p-tiny w-1/12">Bed</th>
                            <th class="p-tiny w-1/12">Days</th>
                            <th class="p-tiny w-1/12">Approved</th>
                            <th class="p-tiny w-1/12">Pmode</th>
                            <th class="p-tiny w-1/12">Discharge Type</th>
                            <th class="p-tiny w-1/12">Comment</th>
                            <th class="p-tiny w-1/12">Bill</th>
                        </tr>
                  </thead>
                  <tbody class="bg-gray-100 text-xs flex flex-col items-center overflow-auto" style="height:70vh;">
                      <tr class="flex w-full">
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>